import { render } from "./BpmnModelerModal.vue?vue&type=template&id=2f9376fb&scoped=true&ts=true"
import script from "./BpmnModelerModal.vue?vue&type=script&lang=ts"
export * from "./BpmnModelerModal.vue?vue&type=script&lang=ts"

import "./BpmnModelerModal.vue?vue&type=style&index=0&id=2f9376fb&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f9376fb"]])

export default __exports__